import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['input', 'dropdown']
  
  select(event) {
    const enterEvent = event.type == 'keydown' && event.keyCode == 13
    const clickEvent = event.type == 'click'
    
    if ( clickEvent || enterEvent ) {
      this.inputTarget.value = event.target.dataset.value
      this.inputTarget.checked = true
    }
  }

}